import { orchestrator } from 'satcheljs';
import { owaConnectedAccountAdded } from 'owa-account-store-init';
import { initializeCalendarsCache } from '../utils/initializeCalendarCache';
import { CalendarEndpointType } from '../store/schema/CalendarEndpointType';

/**
 * Loads the calendars cache when an account is initialized
 */
orchestrator(owaConnectedAccountAdded, actionMessage => {
    initializeCalendarsCache(CalendarEndpointType.Outlook, actionMessage.accountSmtpAddress);
});
